// extracted by mini-css-extract-plugin
module.exports = {"header":"aboutHeader-module--header--1DKfA"};